'use strict';

const getQueryString = require('../modules/util/getQueryString'),
    getQueryStringParams = require('../modules/util/getQueryStringParams'),
    isSmallView = require('../modules/helpers/isSmallView'),
    scrollHelper = require('../modules/helpers/scroll'),
    grid = require('../grid');
const pushDataLayerEvent = require('../modules/helpers/analyticsHelper');

let $currentScrollPos; /* eslint-disable-line */
let alreadyFiltered = false;

const $filterOverlay = $('.js-refinements-bar');
const $filterPage = $('.js-filter-page');
const $filterOptions = $('.js-filter-options');
const $filterBlockTitle = $('.js-filter-block-title');

const $mobileChoosenFilters = $('.js-cop-filters-wrapper');
const $filtersList = $mobileChoosenFilters.find('.js-cop-filters-list');
const $filtersListItem = $filtersList.find('.js-cop-filters-item');

//CHECK WITH FE: seems this does nothing, $currentScrollPos isn't in use
if (navigator.userAgent.match(/(iPhone|iPod|iPad)/i)) {
    $(window).scroll(function () {
        $currentScrollPos = $(document).scrollTop();
    });
}

function priceFilterExists(){
    return $('.js-price-filter-block').length > 0;
}

function initializeEvents() {
    const $body = $('body');

    $body.off('click.filters', '.js-trigger-mobile-filters');
    $body.on('click.filters', '.js-trigger-mobile-filters', function () {
        $filterOverlay.fadeIn('fast', function () {
            const $this = $(this);
            $this.addClass('refinements-visible').removeAttr('aria-hidden');
            redesignAdjustments();
            if (!isSmallView()) {
                const $filterTitleProduct = $this.find('.js-filter-title-product');
                $filterTitleProduct.focus().addClass('open');
                $filterTitleProduct.next('.js-filter-options').show().removeAttr('aria-hidden');
            } else {
                $this.find('.js-filter__block').first().find('.js-filter-block-title').focus();
                $this.find('.js-filter-block-title').removeClass('open');
            }
        });

        // lock body scroll
        scrollHelper.disableScroll();
    });

    const filterBlockSelector = '.js-filter__block input[type=checkbox]';
    $body.off('change.filters', filterBlockSelector);
    $body.on('change.filters', filterBlockSelector, function(){
        const filters = getActiveFilters();
        const lastSelectedFilter = $(this);

        applyFilters(filters, null, lastSelectedFilter);
    });

    $body.off('change.filters','.js-price-filter-input');
    $body.on('change.filters','.js-price-filter-input', function () {
        const anyValueChanged = $('.js-price-filter-input').map(function(_, input) {
            return $(input).val() == $(input).data('previous-value');
        }).get().some(function(result){
            return result === false;
        });

        if (anyValueChanged) {
            $('.js-price-wrapper').data('price-filter-changed', true);
            $('.js-price-filter-btn').removeClass('btn--disabled');
        } else {
            $('.js-price-wrapper').data('price-filter-changed', false);
            $('.js-price-filter-btn').addClass('btn--disabled');
        }
    });

    $body.on('keyup', '.js-price-filter-input', function() {
        $('.js-price-filter-btn').removeClass('btn--disabled');
    });

    $body.off('click.filters','.js-price-filter-btn');
    $body.on('click.filters','.js-price-filter-btn', function () {
        const pricesChanged = $(this).closest('.js-price-wrapper').data('price-filter-changed');
        if (pricesChanged == true) {
            const filters = getActiveFilters();
            applyFilters(filters);
        }
    });

    $body.off('click.filters','.js-clear-all-btn');
    $body.on('click.filters','.js-clear-all-btn', function () {
        $('.js-filter__block input[type=checkbox]').prop('checked', false);
        applyFilters({});
    });

    $body.off('click.filters', '.js-background-overlay, .js-btn-close-filter, .js-filter-x-close, .js-filter-option-close');
    $body.on('click.filters', '.js-background-overlay, .js-btn-close-filter, .js-filter-x-close, .js-filter-option-close', function(){
        if (isSmallView()) {
            if ($filterOptions.hasClass('visible')) {
                $filterOptions.addClass('moved-left');
            }

            $filterOverlay.removeClass('refinements-visible').removeClass('moved-left').attr('aria-hidden', 'true');
            $('.js-search-results-bar').find('.js-trigger-mobile-filters').focus();

            setTimeout(function () {
                $filterOptions.hide().removeClass('visible').removeClass('moved-left').attr('aria-hidden', 'true');
                $filterBlockTitle.removeClass('open');
                $filterOverlay.hide();
            }, 600);
        } else {
            $filterOverlay.removeClass('refinements-visible').attr('aria-hidden', 'true');
            $('.js-search-filter-box').find('.js-trigger-mobile-filters').focus();
            setTimeout(function () {
                $filterOverlay.hide();
            }, 600);
        }

        // unlock body scroll
        scrollHelper.enableScroll();
    });

    $('.js-btn-close-filter').on('keydown', function (e) {
        if (e.which == 9 && !e.shiftKey) {
            e.preventDefault();
            $('.js-filter-x-close').focus();
        }
    });

    $('.js-filter-x-close').on('keydown', function (e) {
        if (e.shiftKey && e.which == 9) {
            e.preventDefault();
            $('.js-btn-close-filter').focus();
        }
    });

    $('.js-cop-filters-button').on('click', function (e) {
        const menuText = e.currentTarget.getAttribute('data-category-name') || '';
        pushDataLayerEvent({
            event: 'menu_navigation',
            menu: 'category_navigation',
            menu_path: breadcrumbPath.toLowerCase(),
            menu_text: menuText.toLowerCase(),
            menu_click: 'text'
        });
    });

    $('.js-breadcrumb-element').on('click', function (e) {
        const span = e.currentTarget.querySelector('span');
        const menuText = span && span.getAttribute('data-name') ? span.getAttribute('data-name') : '';
        pushDataLayerEvent({
            event: 'menu_navigation',
            menu: 'breadcrumb',
            menu_path: breadcrumbPath.toLowerCase(),
            menu_text: menuText.toLowerCase(),
            menu_click: 'text'
        });
    });

    if (isSmallView()) {
        $('.js-filter-block-title').removeAttr('aria-label aria-expanded');
    }

    $body.off('click.filters', '.js-filter-block-title');
    $body.on('click.filters', '.js-filter-block-title', function() {
        const ariaLabelText = $(this).text();
        const ariaLabelStateOpen = $('.js-filter-label-open').text();
        const ariaLabelStateClosed = $('.js-filter-label-closed').text();

        if (!$(this).hasClass('open')) {
            $(this).addClass('open');

            if (isSmallView()) {
                $(this).next('.js-filter-options').show('fast', function () {
                    $filterOverlay.addClass('moved-left');
                    $(this).addClass('visible').addClass('visible').removeAttr('aria-hidden');
                });
                $(this).next('.js-filter-options').find('.js-filter-option-back').focus();
                $(this).removeAttr('aria-label aria-expanded');
            } else {
                $(this).next('.js-filter-options').stop().slideDown().removeAttr('aria-hidden');
                $(this).attr({
                    'aria-label': ariaLabelText + ',' + ariaLabelStateOpen,
                    'aria-expanded' : 'true'
                });
            }
        } else {
            $(this).removeClass('open');

            if (isSmallView()) {
                $(this).next('.js-filter-options').removeClass('visible').attr('aria-hidden', 'true');
                $(this).removeAttr('aria-label aria-expanded');
            } else {
                $(this).next('.js-filter-options').stop().slideUp().attr('aria-hidden', 'true');
                $(this).attr({
                    'aria-label' : ariaLabelText + ',' + ariaLabelStateClosed,
                    'aria-expanded' : 'false'
                });
            }
        }
    });

    $body.off('click.filters', '.js-filter-option-back');
    $body.on('click.filters', '.js-filter-option-back', function () {
        if (isSmallView()) {
            $filterOverlay.removeClass('moved-left');
        }
        $filterOptions.removeClass('visible').attr('aria-hidden', 'true');
        $filterBlockTitle.removeClass('open');

        setTimeout(function () {
            $filterOptions.hide();
        }, 600);
    });

    if (isSmallView()) {
        $filterBlockTitle.on('keydown', function (e) {
            if ($filterOptions.hasClass('visible')) {
                if (e.which == 9) {
                    e.preventDefault();

                    $filterOptions.removeClass('visible').attr('aria-hidden', 'true');
                    $filterBlockTitle.removeClass('open');

                    setTimeout(function () {
                        $filterOptions.hide();
                    }, 600);
                }
            }
        });
    }

    $(document).on('keyup', function(e) {
        if (e.which == 27) {
            // on escape close the overlay
            if ($filterOverlay.hasClass('refinements-visible')) {
                if (isSmallView()) {
                    $filterPage.animate({
                        left: '0'
                    }, 600, 'easeInOutCubic');
                    if ($filterOptions.hasClass('visible')) {
                        $filterOptions.removeClass('visible').attr('aria-hidden', 'true');
                    } else {
                        $filterOverlay.addClass('moved-right').attr('aria-hidden', 'true');
                    }
                    $('.js-search-results-bar').find('.js-trigger-mobile-filters').focus();

                    setTimeout(function () {
                        $filterOverlay.removeClass('refinements-visible').removeClass('moved-right').removeClass('moved-left');
                        $filterBlockTitle.removeClass('open');
                    }, 600);
                } else {
                    $filterOverlay.removeClass('refinements-visible').attr('aria-hidden', 'true');
                    $('.js-search-filter-box').find('.js-trigger-mobile-filters').focus();
                }

                // unlock body scroll
                scrollHelper.enableScroll();
            }
        }
    });

    // only set up history events if not in the outlet. The outlet will have it's own
    if (window.pageContext.ns != 'outlet') {
        setupHistoryEvent();
    }

    setupFilterTagsBehavior();
    accessibilityAdjustments();
    copMobileFiltersInit();

    $(window).on('resize', function () {
        accessibilityAdjustments();
        redesignAdjustments();
        zoomedInWindow();
        copMobileFiltersPosition();
        copMobileFiltersMultipleRows();
    });

    productTypeFilterAdjustments();
}

function keyIsFilterSpecific(key){
    //Key patterns that won't be kept in the query string because they're specific to these filters and controlled in the back-end
    const filterSpecificKeyPatterns = [/prefn[0-9]+/, /prefv[0-9]+/, /pmin/, /pmax/];

    for (const i in filterSpecificKeyPatterns) {
        const regex = filterSpecificKeyPatterns[i];
        if (key.match(regex)) {
            return true;
        }
    }
    return false;
}

/**
 * Gets the status of the active filters
 * Use result as input for applyFilters
 */
function getActiveFilters(){
    const attributeFilters = {};

    $('.js-filter__block input[type=checkbox]').filter(':checked').each(function(_, htmlElement){
        const element = $(htmlElement);

        const attributeId = element.data('attribute-id');
        if (!(attributeId in attributeFilters)) {
            attributeFilters[attributeId] = [];
        }

        attributeFilters[attributeId].push(element.val());
    });

    let priceFilters = {};
    const priceFilterWrapper = $('.js-price-wrapper');
    if (priceFilterWrapper.length > 0) {
        const filteredByPrice = priceFilterWrapper.data('filtered-by-price') === true;
        const changed = priceFilterWrapper.data('price-filter-changed') === true;

        if (changed || filteredByPrice) {
            priceFilters = {
                min: Number($('.js-price-filter-min').val()),
                max: Number($('.js-price-filter-max').val())
            };
        }
    }

    return {
        attributes: attributeFilters,
        price: priceFilters
    };
}

let currentRequestNumber = 0;

/**
 * Applies the selected attribute or price filters
 * @param {Object} filters Object containing the new filters to be applied
 * @param {Boolean} skipHistoryPush If true, don't push this filtering to history
 */
function applyFilters(filters, skipHistoryPush, lastSelectedFilter){
    const params = {filters: JSON.stringify(filters), format: 'ajax'};

    //Put any non-filter parameters in the params to the request, putting back any spaces
    const qsValues = getQueryStringParams(window.location.search);
    for (const key in qsValues) {
        if (!keyIsFilterSpecific(key)) {
            params[key] = qsValues[key].replace('+', ' ');
        }
    }

    const currentSearchResultUrl = $('#currentSearchResultUrl').val();
    currentRequestNumber ++;

    $.ajax({
        url: currentSearchResultUrl,
        type: 'GET',
        data: params
    }).done(getRenderFunction(filters, skipHistoryPush, currentRequestNumber, lastSelectedFilter)); //Render filters when it finishes with success
}

/**
 * Get a rendering function for the filter request, appropriately pushing to history or not.
 * Returned function will call renderFilteredProducts with the appropriate value of `skipHistoryPush`
 *
 * @param {Object} filters Object containing the applied filters, used to save in the history object
 * @param {Boolean} skipHistoryPush If true, don't push this filtering to history
 * @param {Number} requestNumber Used to verify if the response being received is for the most current request.
 */
function getRenderFunction(filters, skipHistoryPush, requestNumber, lastSelectedFilter) {
    return function(data) {
        renderFilteredProducts(data, filters, skipHistoryPush, requestNumber, lastSelectedFilter);
    };
}

/**
 * Renders the result of the AJAX filter request to the back-end
 * @param {String} data The HTML returned by the back-end
 * @param {Object} filters Object containing the new filters to be applied
 * @param {Boolean} skipHistoryPush If true, don't push this filtering to history
 * @param {Number} requestNumber Used to verify if the response being received is for the most current request. Only renders the response if it is
 */
function renderFilteredProducts(data, filters, skipHistoryPush, requestNumber, lastSelectedFilter) {
    if (currentRequestNumber === requestNumber && data) {

        handleGwpAsset(function(){
            $('.js-grid-wrap .js-grid-item').remove();
            $('.js-grid-wrap').append(data);
        });

        if (lastSelectedFilter) {
            $(document).trigger('filterChange', [lastSelectedFilter]);
        }

        const noHits = $('#js-no-hits');
        //Check for the filter status returned in the results. If there, update filters and pills and remove the status hidden input
        const filterStatusElement = $('.js-new-filter-status');
        if (filterStatusElement.length > 0) {
            const filterStatus = JSON.parse(filterStatusElement.last().val());
            updateFilterStatus(filterStatus);
            updateProductTypePills(filterStatus);
            filterStatusElement.remove();
        }

        const newUrlElement = $('.js-new-current-url');
        if (newUrlElement.length > 0) {
            const newUrl = newUrlElement.last().val();
            if (!skipHistoryPush) {
                saveHistory(newUrl, filters);
            }
            updateSortUrls(newUrl);
            newUrlElement.remove();
        }

        grid.updateLoadMoreUrl();

        const newFilterTagsElement = $('.js-new-filter-tags');
        if (newFilterTagsElement.length > 0) {
            const newFilterTags = newFilterTagsElement.last().html();
            const filterTagWrapper = $('.js-active-refinements-list');

            filterTagWrapper.empty();
            filterTagWrapper.append(newFilterTags);
            setupFilterTagsBehavior();

            const numberOfFilters = $('.js-active-refinements').data('number-of-filters') || 0;
            $('.js-filter-count').text(numberOfFilters > 0 ? '(' + numberOfFilters + ')' : '');

            $('.js-cat-quickfilters-popular').toggle(numberOfFilters === 0);

            newFilterTagsElement.remove();
        }

        const newMobileAppliedFiltersElement = $('.js-new-mobile-applied-filters');
        if (newMobileAppliedFiltersElement.length > 0) {
            //Mark all existing mobile filter divs as not updated
            $('.js-mobile-filters').data('updated', false);

            const newAppliedFilters = newMobileAppliedFiltersElement.find('.js-mobile-filters');
            newAppliedFilters.each(function (_, element) {
                const attributeId = $(element).data('attribute-id');
                const visibleElement = $('.js-mobile-filter-' + attributeId);
                visibleElement.html($(element).html());
                visibleElement.data('updated', true);
            });


            //Clear all mobile filters that weren't updated (no filter values for those)
            $('.js-mobile-filters').filter(function (_, element) {
                return $(element).data('updated') === false;
            }).empty();
            newMobileAppliedFiltersElement.remove();
        }

        const newProductCountElement = $('.js-new-product-count');
        if (newProductCountElement.length > 0) {
            const newProductCountMessage = newProductCountElement.last().text();
            $('.js-btn-close-filter').text(newProductCountMessage);

            newProductCountElement.remove();
        }

        if (noHits.length){
            noHits.parent().removeAttr('style').addClass('no-hits-grid');
            return;
        }

        const productFilterBreadcrumbElement = $('.js-product-filter-breadcrumb');
        if (productFilterBreadcrumbElement.length > 0) {
            const productFilterBreadcrumb = productFilterBreadcrumbElement.last().html();
            const breadcrumbWrapper = $('.js-product-search-breadcrumb');

            breadcrumbWrapper.empty();
            breadcrumbWrapper.append(productFilterBreadcrumb);
            setupFilterTagsBehavior();

            productFilterBreadcrumbElement.remove();
        }

        const productCountMsgElement = $('.js-product-count-msg');
        if (productCountMsgElement.length > 0) {
            const productCountMsg = productCountMsgElement.last().val();
            $('.search-results-summary p').html(productCountMsg);

            productCountMsgElement.remove();
        }

        updateProductCountNumber();
        grid.updateProductsSeenAndTotalNumbers();

        $('.js-grid-wrap').imagesLoaded(function () {
            $('.js-grid-wrap').removeClass('no-hits-grid');
            grid.init();
        });
    }
}

function updateProductCountNumber() {
    const productCountElements = $('.js-product-count-number');
    if (!productCountElements.length) {
        return;
    }
    const count = productCountElements.val();
    $('.js-category-products-count').html(count);

    productCountElements.remove();
}

function updateFilterStatus(filterStatus){
    if (!filterStatus) {
        return;
    }

    for (const key in filterStatus) {
        hideOrShowFilterBlock(filterStatus, key);

        if (key === 'price') {
            const priceInfo = filterStatus[key];
            $('.js-price-filter-min').val(priceInfo.min);
            $('.js-price-filter-min').data('previous-value', priceInfo.min);
            $('.js-price-filter-max').val(priceInfo.max);
            $('.js-price-filter-max').data('previous-value', priceInfo.max);
            $('.js-price-wrapper').data('price-filter-changed', false);
            $('.js-price-wrapper').data('filtered-by-price', priceInfo.isRefined);
            $('.js-price-filter-btn').addClass('btn--disabled');
            return;
        }

        const $filterStatusOptions = $('.js-filter-option[data-attribute-id="' + key + '"]');
        $filterStatusOptions.closest('.filter-item').addClass('hide');
        $('[data-filter-type="' + key + '"] .js-filter-product-count').addClass('hide');

        for (const idx in filterStatus[key]) {
            const status = filterStatus[key][idx];
            const input = $('.js-filter-option[data-attribute-id="' + key + '"][value="' + status.value + '"]');

            if (input.length){
                updateFilterInput(input, status);
                continue;
            }
            appendFilterItem(key,status,idx);
        }

    }
}

function hideOrShowFilterBlock(filterStatus, attributeId) {
    const block = $('.js-filter__block[data-filter-type="' + attributeId + '"]');

    if (!block.hasClass('hide')) {
        block.addClass('hide');
    }

    if (filterStatus[attributeId].length) {
        if (attributeId === 'customizable' && filterStatus[attributeId].length === 1 && filterStatus[attributeId][0].value === 'false') {
            // If only Non-customizable products are available don't shop Filter by Customization block
        } else {
            block.removeClass('hide');
        }
    }
}

function updateFilterInput(input, status){
    const countTextElmt = input.parent().find('.js-filter-product-count');

    if (status.count > 0) {
        countTextElmt.text(status.count);
        input.closest('.filter-item').removeClass('hide');
        countTextElmt.removeClass('hide');
    }
}

function appendFilterItem(attributeId, status, idx) {
    let item;

    if (attributeId === 'colorGroupHoR') {
        item = createColorFilterItem(attributeId, status);
    } else {
        item = createFilterItem(attributeId, status);
    }

    if (attributeId === 'duration') {
        item = createDurationFilterItem(attributeId, status);
    } else {
        item = createFilterItem(attributeId, status);
    }

    let target;
    if (attributeId === 'customizable') {
        if (status.value === 'true') {
            target = $('.js-filter-option[data-attribute-id="' + attributeId + '"]').eq(0).parents('.filter-item');
        } else {
            const filterOptions = $('.js-filter-option[data-attribute-id="' + attributeId + '"]');
            target = $('.js-filter-option[data-attribute-id="' + attributeId + '"]').eq(filterOptions.length - 1).parents('.filter-item');
            item.insertAfter(target);
            return;
        }
    } else {
        target = $('.js-filter-option[data-attribute-id="' + attributeId + '"]').eq(idx).parents('.filter-item');
    }
    item.insertBefore(target);
}

function createFilterItem(attributeId, status){
    const clonedElement = $('.filter-item').first().clone();
    const input = clonedElement.find('input.js-filter-option');
    input.attr('data-attribute-id', attributeId);
    input.attr('value', status.value);
    input.prop('checked', false);
    const countTextElmt = clonedElement.find('.js-filter-product-count');
    countTextElmt.text(status.count).removeClass('hide');
    const text = clonedElement.find('span.text').text(status.displayValue).append(countTextElmt).removeClass().addClass('text');

    if (attributeId == 'ritual') {
        const ritualColor = status.value.toLowerCase() + '-bg-full-color';
        text.addClass(ritualColor);
    }

    if (status.count > 0) {
        clonedElement.removeClass('hide');
        return clonedElement;
    }

    clonedElement.addClass('hide');
    return clonedElement;
}

function createColorFilterItem(attributeId, status) {
    const filterItem = $('<div><div>').addClass('filter-item filter-item-circle');
    const label = $('<label></label>');
    const input = $('<input></input>').attr('type', 'checkbox')
        .addClass('option js-filter-option')
        .attr('value', status.value)
        .attr('data-attribute-id', attributeId)
        .attr('data-filter-name', status.value);
    const span = $('<span></span>').addClass('text ' + status.value.toLowerCase() + '-product-color').text(status.displayValue);
    const sup = $('<sup></sup>').addClass('js-filter-product-count').text(status.count);
    const spanCheckbox = $('<span></span>').addClass('text-checkbox');

    span.append(sup, spanCheckbox);
    label.append(input, span);
    filterItem.append(label);
    return filterItem;
}


function createDurationFilterItem(attributeId, status) {
    const filterItem = $('<div><div>').addClass('filter-item filter-item-circle');
    const label = $('<label></label>');
    const input = $('<input></input>').attr('type', 'checkbox')
        .addClass('option js-filter-option')
        .attr('value', status.value)
        .attr('data-attribute-id', attributeId)
        .attr('data-filter-name', status.value);
    const span = $('<span></span>').addClass('text ' + status.value.toLowerCase()).text(status.displayValue);
    const sup = $('<sup></sup>').addClass('js-filter-product-count').text(status.count);
    const spanCheckbox = $('<span></span>').addClass('text-checkbox');

    span.append(sup, spanCheckbox);
    label.append(input, span);
    filterItem.append(label);
    return filterItem;
}

/**
 * Saves the current filter state into the browser history
 * @param {string} url The url to save in history
 * @param {Array} selectedFilters Array with the currently selected filters, to save in the history state
 */
function saveHistory(url, selectedFilters){
    if (!alreadyFiltered) {
        alreadyFiltered = true;
        history.pushState(selectedFilters, '', url);
    } else {
        history.replaceState(selectedFilters, '', url);
    }
}

function handleGwpAsset(appendTiles){
    const gwpAsset = $('.js-grid-wrap .js-grid-item:first > .js-search-grid-asset').clone();

    if (appendTiles !== undefined && $.isFunction(appendTiles)) {
        appendTiles();
    }

    if (gwpAsset.length){
        gwpAsset.appendTo($('.js-grid-wrap .js-grid-item:first'));
    }

}
/**
 * Sets up the behavior for the filter tags.
 * Clicking the "desktop" tags removes the values one by one,
 */
function setupFilterTagsBehavior(){
    const $body = $('body');

    $body.off('click.filters', '.js-active-refinements .js-remove-filter-button');
    $body.on('click.filters', '.js-active-refinements .js-remove-filter-button', function(){
        const refinementAttribute = $(this).data('refinement-attribute');
        const refinementValue = $(this).data('refinement-value');
        $('.js-filter-option[data-attribute-id="' + refinementAttribute + '"][value="' + refinementValue + '"]').prop('checked', false);

        const filters = getActiveFilters();
        applyFilters(filters, false, $(this));

        $(this).closest('.js-filter-tag').remove();
    });

    if (priceFilterExists()){
        $body.off('click.filters', '.js-remove-price-filter-button');
        $body.on('click.filters', '.js-remove-price-filter-button', function(){
            const filters = getActiveFilters();
            filters.price = {};
            applyFilters(filters);

            $(this).closest('.js-filter-tag').remove();
        });
    }
}

/**
 * Sets up the event to fire when history navigation happens
 */
function setupHistoryEvent(){
    window.onpopstate = function(history){
        if (history.state) {
            applyFilters(history.state, true);
        } else {
            alreadyFiltered = false; //We left the filter history
            applyFilters({}, true);
        }
    };
}

/**
 * Builds a query string from an object with the individual values
 * @param {object} qsValues Object with the values to include in the query string, in the form {key: value}
 */
function buildQueryString(qsValues){
    const qsParts = [];

    for (const key in qsValues) {
        qsParts.push(key + '=' + encodeURIComponent(qsValues[key]));
    }

    return qsParts.join('&');
}

/**
 * Removes the query string part from a URL
 * @param {string} url
 */
function removeQueryString(url){
    return url.split('?')[0];
}

/**
 * Updates the sorting dropdown options with the currently selected filters
 */
function updateSortUrls(currentUrl) {
    const SORT_RULE_PARAM = 'srule',
        PAGING_PAGE_SIZE = 'sz',
        PAGING_START = 'start',
        QUERY = 'q';

    $('.js-sorting-options option:not([hidden])').each(function () {
        const sortUrl = $(this).val();
        const sortQsValues = getQueryStringParams(getQueryString(sortUrl));

        const currentUrlNoQs = removeQueryString(currentUrl);
        const currentQSValues = getQueryStringParams(getQueryString(currentUrl));

        if (sortQsValues[SORT_RULE_PARAM]) {
            currentQSValues[SORT_RULE_PARAM] = sortQsValues[SORT_RULE_PARAM];
        }
        if (sortQsValues[PAGING_PAGE_SIZE]) {
            currentQSValues[PAGING_PAGE_SIZE] = sortQsValues[PAGING_PAGE_SIZE];
        }
        if (sortQsValues[PAGING_START]) {
            currentQSValues[PAGING_START] = sortQsValues[PAGING_START];
        }
        if (sortQsValues[QUERY]) {
            currentQSValues[QUERY] = sortQsValues[QUERY];
        }

        let finalUrl = currentUrlNoQs;
        const finalQs = buildQueryString(currentQSValues);

        if (finalQs) {
            finalUrl += '?' + finalQs;
        }

        $(this).val(finalUrl);
    });
}

function accessibilityAdjustments() {
    if (isSmallView()) {
        $('.js-filter-category-title').attr('aria-hidden', 'true');
    } else {
        $('.js-filter-category-title').removeAttr('aria-hidden');
    }
}

function redesignAdjustments() {
    const $filterInner = $('.js-filter-inner');
    const filterHeaderHeight = $('.js-filter-header').outerHeight();

    $filterInner.css('padding-top', filterHeaderHeight);
}

function productTypeFilterAdjustments() {
    if (!history.state || !history.state.attributes || !history.state.attributes.productType) {
        return;
    }

    const historyProductTypes = history.state.attributes.productType;
    const $productTypes = $('.js-filter__block input[type=checkbox]').filter(function() {
        return $(this).data('attribute-id') == 'productType';
    });

    $productTypes.each(function() {
        const $this = $(this);
        const shouldBeChecked = historyProductTypes.indexOf($this.val()) != -1;

        if (shouldBeChecked) {
            $this.prop('checked', true);
        } else {
            $this.prop('checked', false);
        }
    });
}

function copMobileFiltersInit() {
    $filtersListItem.each(function () {
        if ($(this).hasClass('selected')) {
            $(this).find('.js-cop-filters-text').attr('tabindex', '-1');
        }
    });

    copMobileFiltersWidth();
    copMobileFiltersToggle();
    copMobileFiltersGradient();
}

function zoomedInWindow() {
    if (window.outerWidth > 1024 && !$('body').hasClass('zoomed-in')) {
        $('body').addClass('zoomed-in');
    }
}

function copMobileFiltersWidth() {
    zoomedInWindow();

    if ($mobileChoosenFilters.length && !$('body').hasClass('zoomed-in')) {
        $filtersList.addClass('no-wrap');
        const filtersListWidth = $filtersList[0].scrollWidth;
        $filtersList.css('width', filtersListWidth);
    } else if ($mobileChoosenFilters.length && $('body').hasClass('zoomed-in')) {
        copMobileFiltersPosition();
        copMobileFiltersMultipleRows();
    }
}

function copMobileFiltersToggle() {
    $('.js-filter-show-more').on('click', function (e) {
        const $this = $(this);
        e.preventDefault();
        if (!$this.hasClass('active')) {
            $this.addClass('active');
            $mobileChoosenFilters.addClass('expanded');
            $filtersListItem.each(function () {
                $(this).removeClass('hidden');
                if ($(this).hasClass('selected')) {
                    $filtersListItem.first().find('.js-cop-filters-button').not('.js-cop-filters-text').focus();
                } else {
                    $filtersListItem.first().find('.js-cop-filters-button').first().focus();
                }
            });
        } else {
            $this.removeClass('active');
            $mobileChoosenFilters.removeClass('expanded');
            copMobileFiltersPosition();
        }
    });
}

function copMobileFiltersPosition() {
    $filtersListItem.each(function () {
        if ($(this).position().top > 0) {
            $(this).addClass('hidden');
        }
    });
}

function copMobileFiltersMultipleRows() {
    if ($filtersList.find('.hidden').length < 1) {
        $('.js-filter-show-more').hide();
    } else {
        $('.js-filter-show-more').show();
    }
}

function copMobileFiltersGradient() {
    if ($mobileChoosenFilters.length) {
        const filtersListWidth = $filtersList[0].scrollWidth;
        const windowWidth = $(window).width() + 10;

        if (filtersListWidth > windowWidth) {
            $mobileChoosenFilters.addClass('right-fade');
        }


        $filtersList.bind('touchmove', function() {
            const listPosition = $filtersList.position().left;
            const listHidden = -1 * listPosition;
            const listVisible = filtersListWidth - listHidden;

            if (filtersListWidth > windowWidth) {
                if (listPosition < -10) {
                    $mobileChoosenFilters.addClass('left-fade');
                } else {
                    $mobileChoosenFilters.removeClass('left-fade');
                }

                if (listVisible > windowWidth) {
                    $mobileChoosenFilters.addClass('right-fade');
                } else {
                    $mobileChoosenFilters.removeClass('right-fade');
                }
            }
        });
    }
}

function initProductTypeFilter(){
    const productTypeFilterSelector = '.js-product-type-filter:not(.selected) .js-apply-filter';
    $(document).off('click.filters', productTypeFilterSelector).on('click.filters', productTypeFilterSelector,
        function(e) {
            triggerCheckboxClick(e, true);
        }
    );

    $(document).off('click.filters', '.js-clear-product-type-filter').on('click.filters','.js-clear-product-type-filter',
        function(e) {
            triggerCheckboxClick(e, false);
        }
    );
}

function createBreadcrumbPath() {
    const path = $('.breadcrumb .breadcrumb-list-item a span')
        .map(function () {
            let dataName = $(this).attr('data-name');
            return dataName && dataName.trim();
        })
        .get()
        .join(', ');

    return path;
}

const breadcrumbPath = createBreadcrumbPath();

function triggerCheckboxClick(e, addClass){
    e.preventDefault();
    const $this = $(e.target).parents('li');
    const matchingCheckbox = $('.js-filter-option[data-attribute-id="' + $this.data('refinement-attribute') + '"][value="' + $this.data('refinement-value') + '"]');
    const checkboxText = $this.data('refinement-name') || '';
    matchingCheckbox.trigger('click');


    if (addClass){
        $this.addClass('selected');
        pushDataLayerEvent({
            event: 'menu_navigation',
            menu: 'category_navigation',
            menu_path: breadcrumbPath.toLowerCase(),
            menu_text: checkboxText.toLowerCase(),
            menu_click: 'text'
        });
        return;
    }
    $this.removeClass('selected');
}

function updateProductTypePills(filterStatus) {
    if (!filterStatus) {
        return;
    }

    $('.js-product-type-filter').each(function() {
        $(this).hide();
    });

    for (const key in filterStatus) {
        if (['productType', 'customizable'].indexOf(key) > -1) {
            for (const idx in filterStatus[key]) {
                const status = filterStatus[key][idx];
                const filterCheckbox = $('.js-filter-option[data-attribute-id="' + key + '"][value="' + status.value + '"]');
                let filterPill = $('.js-product-type-filter[data-refinement-attribute="' + key + '"][data-refinement-value="' + status.value + '"]');

                if (!filterPill.length) {
                    appendMissingProductTypePill(status, key, idx);
                    filterPill = $('.js-product-type-filter[data-refinement-attribute="' + key + '"][data-refinement-value="' + status.value + '"]');

                }
                filterPill.show();

                if (filterCheckbox.is(':checked')) {
                    filterPill.addClass('selected');
                    filterPill.children('.js-apply-filter').attr('tabindex', '1');
                } else {
                    filterPill.removeClass('selected');
                    filterPill.children('.js-apply-filter').removeAttr('tabindex', '1');
                }
            }
        }
    }
}

function appendMissingProductTypePill(status, attributeId) {
    if (attributeId === 'customizable' && status.value == 'true') {
        const customizablePillItem = createProductTypePill(status, attributeId);
        $('.js-product-type-filters').prepend(customizablePillItem);
    } else if (attributeId === 'productType') {
        const productTypePillItem = createProductTypePill(status, attributeId);
        $('.js-product-type-filters').append(productTypePillItem);
    }
}

function createProductTypePill(status, attributeId) {
    const pillItem = $('<li></li>').addClass('js-cop-filters-item js-product-type-filter');
    pillItem.attr('data-refinement-attribute', attributeId).attr('data-refinement-value', status.value);

    const applyFilterButton = $('<button></button>').addClass('text js-apply-filter');

    applyFilterButton.append(status.displayValue);

    const removeFilterButton = $('<button></button>').addClass('remove-filter js-clear-product-type-filter');
    removeFilterButton.append('<span class="icon icon-close"></span>');

    return pillItem.append(applyFilterButton, removeFilterButton);
}

exports.init = function () {
    initializeEvents();
    initProductTypeFilter();
};

exports.handleGwpAsset = handleGwpAsset;
